<template>
  <div class="duration-filter">
    <span>{{ t("components.eventAction.filter.ui.Overdue.text") }}</span>
    <div class="duration-inputs">
      <LISAInputNumber v-model.number="numberOfHours" style="font-size: inherit" />

      <LISASelect v-model="timeMultiplier" :options="multiplierOptions" class="w-100" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { LISASelect, type LISASelectOption } from "@fi-solutions/lisa-ui";
import { computed, ref } from "vue";
import { useTranslation } from "@/language/translation";
import OverdueFilter from "../filterImplementations/OverdueFilter";
import LISAInputNumber from "@/components/primevueWrapper/LISAInputNumber.vue";

const { t } = useTranslation();
const numberOfHours = ref<number>();
const timeMultiplier = ref<1 | 24>(24);
const multiplierOptions = computed<LISASelectOption[]>(() => [
  {
    label: t("global.hours"),
    id: 1,
  },
  {
    label: t("global.days"),
    id: 24,
  },
]);
function getFilter() {
  return numberOfHours.value == null
    ? null
    : new OverdueFilter(numberOfHours.value * timeMultiplier.value);
}
function applyFilter(filter: OverdueFilter) {
  if (filter.definitionOfOverdueInHours % 24 === 0) {
    timeMultiplier.value = 24;
    numberOfHours.value = filter.definitionOfOverdueInHours / 24;
  } else {
    timeMultiplier.value = 1;
    numberOfHours.value = filter.definitionOfOverdueInHours;
  }
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>

<style lang="scss" scoped>
.duration-filter,
.duration-inputs {
  display: flex;
  min-width: 0;
  align-items: center;
}

.duration-filter {
  gap: 0.75rem;
}

.duration-filter > span {
  flex: 1 1 auto;
}

.duration-inputs {
  min-width: 14rem;
  flex: 0 1 18rem;
}
</style>
